module.exports = __webpack_public_path__ + "img/exhibition.09560550.png";